import React, { useEffect, useRef } from 'react';
import { Table, Badge, Button, Spinner, Alert } from 'reactstrap';

const CentroCostosTable = ({ centrosCosto, onExport, loading, error }) => {
  const errorRef = useRef(null);

  // Scroll al error cuando aparezca
  useEffect(() => {
    if (error && errorRef.current) {
      errorRef.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }, [error]);

  if (loading) {
    return (
      <div data-testid="loading" className="text-center py-4">
        <Spinner color="primary" />
        <p className="mt-2">Cargando centros de costo...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert ref={errorRef} color="danger" data-testid="error" timeout={0}>
        {error}
      </Alert>
    );
  }

  return (
    <div data-testid="centro-costos-table">
      <Table responsive striped hover>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Proceso</th>
            <th>Encargado</th>
            <th>Proveedor</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {!centrosCosto || centrosCosto.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center py-4">
                <p className="mb-0">No hay centros de costo disponibles</p>
              </td>
            </tr>
          ) : (
            centrosCosto.map((centro) => (
              <tr key={centro.id}>
                <td>{centro.nombre}</td>
                <td>{centro.proceso || 'N/A'}</td>
                <td>{centro.encargado || 'N/A'}</td>
                <td>{centro.proceso_proveedor || 'N/A'}</td>
                <td>
                  <Badge color={centro.activo ? 'success' : 'secondary'}>
                    {centro.activo ? 'Activo' : 'Inactivo'}
                  </Badge>
                </td>
                <td>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => onExport(centro.id)}
                    data-testid={`export-btn-${centro.id}`}
                  >
                    Exportar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CentroCostosTable;
